/* eslint-disable */
export default {
  topic: 'Nombre de la reunión',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
